export const iframeMessageHookMap = {};
export const registerIframeMessageHook = (type, hook, handleMessage) => {
    iframeMessageHookMap[type] = { hook, handleMessage };
};
//# sourceMappingURL=IframeRegistration.js.map